import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ADESAO.ESTORNO.HISTORICO.BUSCAR](context, objBusca) {
		let { data } = await api.itemAdesaoEstorno.buscarHistorico(objBusca)
		return data
	},
}
